// Matomo Analytics Configuration

// This file contains the configuration for Matomo Analytics integration
// Replace the URL and siteId with your actual Matomo instance details
export const MATOMO_CONFIG = {
  urlBase: 'https://matomo.stuffsclub.net/',
  siteId: 1, // Update after completing Matomo setup wizard
  trackerUrl: 'https://matomo.stuffsclub.net/matomo.php',
  srcUrl: 'https://matomo.stuffsclub.net/matomo.js',
  disabled: false, // Set to true to disable tracking (useful for development/testing)
  heartBeat: { // Tracks the actual time spent on the page
    active: true,
    seconds: 10
  },
  linkTracking: true, // Enables tracking of outbound links
  configurations: { // Additional tracker configurations
    disableCookies: false,
    setSecureCookie: true,
    setRequestMethod: 'POST'
  }
};